import { useCallback, useEffect, useRef } from 'react';

import { Icon } from 'components/Icon/Icon';
import { getItem, setItem } from 'utils/localStorage';

import {
  NotificationsDropdownIconHolder,
  NotificationsDropdownIconRedDot,
  NotificationsDropdownIconWiggle,
} from './NotificationsDropdownIcon.styled';

const MAX_NOTIFICATION_COUNT = 99;

type Props = {
  unseenNotificationsCount: number;
};

export function NotificationsDropdownIcon({ unseenNotificationsCount }: Props) {
  const wiggleRef = useRef<HTMLDivElement>(null);

  const handleAnimationEnd = useCallback(() => {
    wiggleRef.current?.classList.remove('animate');
  }, []);

  useEffect(() => {
    const previousLocalNotificationLength = getItem('unseenNotificationLength');

    // Compare the current to the previously unseen notifications
    // and determine whether, or not to animate the notifications bell.
    if (
      wiggleRef.current &&
      unseenNotificationsCount !== 0 &&
      previousLocalNotificationLength !== unseenNotificationsCount
    ) {
      wiggleRef.current?.classList.add('animate');

      setItem('unseenNotificationLength', unseenNotificationsCount);
    }
  }, [unseenNotificationsCount]);

  return (
    <NotificationsDropdownIconHolder>
      {unseenNotificationsCount > 0 && (
        <NotificationsDropdownIconRedDot>
          {unseenNotificationsCount > MAX_NOTIFICATION_COUNT ? (
            <>&infin;</>
          ) : (
            unseenNotificationsCount
          )}
        </NotificationsDropdownIconRedDot>
      )}

      <NotificationsDropdownIconWiggle
        ref={wiggleRef}
        onAnimationEnd={handleAnimationEnd}
      >
        <Icon name="bell-2" size={22} />
      </NotificationsDropdownIconWiggle>
    </NotificationsDropdownIconHolder>
  );
}
